import { jsxs as l, jsx as e } from "react/jsx-runtime";
const i = (d) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ...d,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#segment-colored_svg__a)", children: [
        /* @__PURE__ */ e(
          "mask",
          {
            id: "segment-colored_svg__b",
            width: 23,
            height: 11,
            x: 0,
            y: 14,
            maskUnits: "userSpaceOnUse",
            style: {
              maskType: "alpha"
            },
            children: /* @__PURE__ */ e("path", { fill: "#fff", d: "M22.704 24.113H0v-9.348h22.704z" })
          }
        ),
        /* @__PURE__ */ l(
          "g",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            mask: "url(#segment-colored_svg__b)",
            children: [
              /* @__PURE__ */ e(
                "path",
                {
                  fill: "#93C8A2",
                  d: "M14.96 17.07H1.153a1.152 1.152 0 1 1 0-2.305h13.809a1.152 1.152 0 1 1 0 2.305"
                }
              ),
              /* @__PURE__ */ e(
                "path",
                {
                  fill: "#43AF79",
                  d: "M12 24.13c-1.125 0-2.236-.167-3.302-.498a1.153 1.153 0 0 1 .682-2.202 8.8 8.8 0 0 0 2.62.395c3.91 0 7.306-2.51 8.45-6.247a1.153 1.153 0 0 1 2.203.675A11.08 11.08 0 0 1 12 24.13"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fill: "#93C8A2",
            fillRule: "evenodd",
            d: "M22.848 11.215H9.04a1.152 1.152 0 1 1 0-2.305h13.808a1.152 1.152 0 1 1 0 2.305",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fill: "#43AF79",
            fillRule: "evenodd",
            d: "M2.449 11.216a1.152 1.152 0 0 1-1.102-1.49A11.08 11.08 0 0 1 12 1.85c1.126 0 2.237.167 3.302.498a1.153 1.153 0 1 1-.682 2.201A9 9 0 0 0 12 4.158a8.79 8.79 0 0 0-8.45 6.247 1.15 1.15 0 0 1-1.1.815",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fill: "#93C8A2",
            fillRule: "evenodd",
            d: "M19.993 5.671a1.153 1.153 0 1 1-2.305 0 1.153 1.153 0 0 1 2.305 0M6.312 20.311a1.153 1.153 0 1 1-2.306 0 1.153 1.153 0 0 1 2.306 0",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "segment-colored_svg__a", children: /* @__PURE__ */ e("path", { fill: "#fff", d: "M0 .85h24v24H0z" }) }) })
    ]
  }
);
export {
  i as default
};
